module.exports = __webpack_public_path__ + "img/homefooter_icon02.03f02bd3.png";